import { useQuery } from '@hooks/reactQuery';

import { getRUStatusDashboardAvailabilityState } from '@api/ruStatusDashboard';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_DASHBOARD_AVAILABILITY_STATE } from '@constants/queryKeys';

interface IUseQueryRUDashboardStatusAvailabilityState {
	ruDashboardStatusAvailabilityState: TSelectOption<string>[];
	isLoadingRUDashboardStatusAvailability: boolean;
}

export const useQueryRUDashboardStatusAvailabilityState = (): IUseQueryRUDashboardStatusAvailabilityState => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [RU_DASHBOARD_AVAILABILITY_STATE],
		queryFn: getRUStatusDashboardAvailabilityState,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		allowedRoles: [
			EUserRoles.smoLightUpdater,
			EUserRoles.smoLightViewer,
		],
		...refetchOptions,
	});

	return {
		ruDashboardStatusAvailabilityState: data || [],
		isLoadingRUDashboardStatusAvailability: isInitialLoading,
	};
};
